module.exports = __webpack_public_path__ + "static/img/icon-history.635411f.png";